/* Cartao de visita */
export const FIND_BY_ID_OR_URLID = {
  url: 'business-card/show-by-id-or-urlid/{idOrUrlid}',
  method: 'GET'
};
